export default __webpack_public_path__ + "static/media/5_3_hl.89b7bb0e.png";